document.addEventListener("DOMContentLoaded", function () {
  const stickyBtn = document.getElementById("sticky-cart-btn");
  const stickyCount = document.getElementById("sticky-cart-count");

  if (!stickyBtn || !stickyCount) return;

  function getCartCountNode() {
    return document.querySelector(".cart-item-count-header.cart-item-count-header--quantity");
  }

  function updateStickyCart() {
    const cartCountEl = getCartCountNode();
    let num = 0;
    if (cartCountEl && cartCountEl.textContent.trim()) {
      num = parseInt(cartCountEl.textContent.trim(), 10) || 0;
    }
    if (window.scrollY > 150 && num > 0) {
      stickyBtn.style.display = "flex";
      stickyCount.textContent = num;
    } else {
      stickyBtn.style.display = "none";
    }
  }

  const headerIcons = document.querySelector(".cart-icon-wrapper");
  if (headerIcons) {
    const observer = new MutationObserver(updateStickyCart);
    observer.observe(headerIcons, { childList: true, subtree: true, characterData: true });
  }

  function observeCartCount() {
    const cartCountEl = getCartCountNode();
    if (cartCountEl) {
      const countObserver = new MutationObserver(updateStickyCart);
      countObserver.observe(cartCountEl, { childList: true, characterData: true, subtree: true });
    }
  }
  observeCartCount();

  if (headerIcons) {
    const iconsObserver = new MutationObserver(() => {
      updateStickyCart();
      observeCartCount();
    });
    iconsObserver.observe(headerIcons, { childList: true, subtree: true, characterData: true });
  }

  window.addEventListener("scroll", updateStickyCart);

  setTimeout(updateStickyCart, 350);

  stickyBtn.addEventListener("click", function () {
    const cartBtn = document.querySelector(".cart-icon-wrapper");
    if (cartBtn) {
      cartBtn.click();
    } else {
      window.location.href = "{{ routes.cart_url }}";
    }
  });
});
